export default {
  'FormattedPayoutScreen.status': { en: 'Status', fr: 'Status' },
  'FormattedPayoutScreen.number': { en: 'Number', fr: 'Numero' },
  'FormattedPayoutScreen.customer': { en: 'Customer', fr: 'Client' },
  'FormattedPayoutScreen.date': { en: 'Date', fr: 'Date' },
  'FormattedPayoutScreen.amount': { en: 'Amount', fr: 'Montant' },
  'FormattedPayoutScreen.view': { en: 'View', fr: 'Voir' },
};
